import React, { useState } from "react";
import "./StepIndicator.css";
// import d1 from '../../assets/images/d1.svg'
const StepIndicator = () => {
  const [activeStep, setActiveStep] = useState("Discover");

  const stepData = [
    {
      step: "Discover",
      title: "Discover",
      description:
        "Uncover the market landscape, audience behaviours, and real-world data that inform compelling strategies.",
      imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d1.svg",
    },
    {
      step: "Define",
      title: "Define",
      description:
        "Translating insights into a clear brand purpose, identity, and positioning that guide every future decision. ",
      imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d2.svg",
    },
    {
      step: "Develop",
      title: "Develop",
      description:
        "Collaboration across disciplines to turn ideas into tangible deliverables—such as visual identities, campaigns, and content.",
      imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d3.svg",
    },
    {
      step: "Deliver",
      title: "Deliver",
      description:
        "Executing plans, measuring outcomes, and refining ongoing impact and relevance in the marketplace. ",
      imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d4.svg",
    },
  ];

  // Find the index based on the step name
  const activeIndex = stepData.findIndex(item => item.step === activeStep);
  const { title, description, imgSrc } = stepData[activeIndex];

  const handleStepClick = (stepName) => {
    setActiveStep(stepName);
  };

  return (
    <div className="step-indicator-container four_d">
      <div className="steps-container">
        {stepData.map((step, index) => (
          <div
            key={index}
            className={`step ${activeStep === step.step ? "active" : ""}`}
            onClick={() => handleStepClick(step.step)}
          >
            {step.step}
          </div>
        ))}
      </div>

      <div className="step-content">
        <img src={imgSrc} alt={`Step ${activeStep} illustration`} className="step-image" />
        <div className="step-text">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      <div className="four_process">
      <p className="p_txt">The 4D Process simplifies the brand-building experience, ensuring consistency and purpose at every step, even while working in a community. </p>
      </div>
    </div>
  );
};

export default StepIndicator;
